
export class PricingSchemeModel {
    pricingSchemeAccessKey:string;
    uom: string;
    price_name: string;
    price_code:string;
    price_amount_incl_tax: string | 0;
    price_amount_excl_tax:string | 0;
    price_min: string | 0;
    price_max: string | 0;
    guid_pricing_scheme_hdr: string;
    replacement_unit_price_excl_tax: string | 0;
    ref_price1_excl_tax: string | 0;
    ref_price2_excl_tax: string | 0;
    ref_price3_excl_tax: string | 0;
    delta_price1_excl_tax: string | 0;
    delta_price2_excl_tax: string | 0;
    delta_price3_excl_tax: string | 0;
    rebate_price1_excl_tax: string | 0;
    rebate_price2_excl_tax: string | 0;
    rebate_price3_excl_tax: string | 0;
    sales_min_price_excl_tax: string | 0;
    sales_max_price_excl_tax: string | 0;
    purchase_min_price_excl_tax: string | 0;
    purchase_max_price_excl_tax: string | 0;
    guid_pricing_scheme_link: string;
    purchase_selling_list_price_incl_tax: string | 0;
    taxCode: string;
    taxRate: number;
    taxType: string;
}
